mutation CompanyBusinessRuleUpdate($input: CompanyBusinessRuleUpdateInput!) {
  companyBusinessRuleUpdate(input: $input) {
    clientMutationId
    boolean
  }
}
